import { FuseNavigationItem } from "@fuse/components/navigation";
import { AppContextModel } from "@store/models/context-model";
import { Constants } from "app/core/constants/constants";

export const defaultNavigation: FuseNavigationItem[] = [
    /** global routes */
    {
        id: Constants.folderIdRoute,
        type: "group",
        context: AppContextModel.globalContext,
        children: [
            {
                id: "dashboard",
                title: "nav.dashboard_title",
                type: "basic",
                link: Constants.dashboardRoute,
                context: AppContextModel.globalContext,
                moduleCodeName: Constants.MODULES.DASHBOARD,
                icon: "heroicons_outline:dashboard",
                classes: {
                    icon: ["bg-[#1F9CFF]"],
                },
            },
            {
                id: Constants.crudFolderIdRoute,
                title: "nav.folder_title",
                type: "basic",
                icon: "heroicons_outline:folder",
                context: AppContextModel.globalContext,
                exactMatch: true,
                classes: {
                    icon: ["bg-[#AC25C3]"],
                },
            },
            {
                id: Constants.clientsIdRoute,
                title: "nav.clients_title",
                type: "collapsable",
                icon: "heroicons_outline:customers",
                context: AppContextModel.globalContext,
                exactMatch: true,
                moduleCodeName: Constants.MODULES.CLIENT,
                classes: {
                    icon: ["bg-[#f54337]"],
                },
                children: [
                    {
                        id: Constants.allClientsIdRoute,
                        title: "nav.all_clients_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.CLIENT,
                        link: Constants.clientsRoute,
                        icon: "heroicons_outline:customers-new",
                    },
                    {
                        id: Constants.allClientsFamilyIdRoute,
                        title: "nav.client_family_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.CLIENT_FAMILY,
                        link: Constants.clientsFamilyRoute,
                        icon: "heroicons_outline:customers2-new",
                    },
                ]
            },
            {
                id: Constants.productsIdRoute,
                title: "nav.products_title",
                type: "collapsable",
                icon: "heroicons_solid:archive-box",
                context: AppContextModel.globalContext,
                exactMatch: true,
                moduleCodeName: Constants.MODULES.PRODUCT,
                classes: {
                    icon: ["bg-[#4CAF50]"],
                },
                children: [
                    {
                        id: Constants.allProductsIdRoute,
                        title: "nav.all_products_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.PRODUCT,
                        link: Constants.productsRoute,
                        icon: "heroicons_outline:product-new",
                        exactMatch: true,
                    },
                    {
                        id: Constants.allProductsFamilyIdRoute,
                        title: "nav.product_family_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.PRODUCT_FAMILY,
                        link: Constants.productsFamilyRoute,
                        icon: "heroicons_outline:product-group-new",
                        exactMatch: true,
                    },
                    {
                        id: Constants.pricesIdRoute,
                        title: "nav.prices_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.PRICE_LIST,
                        link: "/all-prices",
                        icon: "heroicons_outline:cost2-new",
                        exactMatch: true,
                    },
                ]
            },
            {
                id: Constants.productionIdRoute,
                title: "nav.production_title",
                type: "collapsable",
                icon: "heroicons_outline:production_icon",
                context: AppContextModel.globalContext,
                exactMatch: true,
                classes: {
                    icon: ["bg-[#FF9800]"],
                },
                children: [
                    {
                        id: Constants.allProcessIdRoute,
                        title: "nav.all_process_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.PROCESS,
                        link: Constants.processRoute,
                        icon: "heroicons_outline:process_icon",
                    },
                    {
                        id: Constants.allFormulasIdRoute,
                        title: "nav.all_formulas_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.FORMULA,
                        link: Constants.formulasRoute,
                        icon: "heroicons_outline:calculate-icon"
                    },
                    {
                        id: Constants.allExecutionIdRoute,
                        title: "nav.all_executions_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.EXECUTION,
                        link: Constants.executionRoute,
                        icon: "heroicons_outline:execution_icon",
                    },
                    {
                        id: Constants.machineIdRoute,
                        title: "nav.all_machines_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.MACHINE,
                        link: Constants.allMachineRoute,
                        icon: "heroicons_outline:machine_icon",
                    },
                ]
            },
            {
                id: Constants.vouchersIdRoutes,
                title: "nav.stock_title",
                type: "collapsable",
                icon: "heroicons_solid:archive-box",
                classes: {
                    icon: ["bg-[#27c942]"],
                },
                exactMatch: true,
                children: [
                    {
                        id: Constants.MODULES.ENTRY_VOUCHER,
                        title: "nav.entry_vouchers",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.ENTRY_VOUCHER,
                        icon: "heroicons_outline:cost2-new",
                        link: Constants.entryVouchersRoute
                    },
                    {
                        id: Constants.MODULES.EXIT_VOUCHER,
                        title: "nav.exit_vouchers",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.EXIT_VOUCHER,
                        icon: "heroicons_outline:cost2-new",
                        link: Constants.exitVouchersRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.TRANSFER_VOUCHER,
                        title: "nav.transfer_vouchers",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.TRANSFER_VOUCHER,
                        icon: "heroicons_outline:cost2-new",
                        link: "all-transfer-vouchers",
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.DAMAGE,
                        title: "nav.damages_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.DAMAGE,
                        icon: "heroicons_outline:damages-icon",
                        link: Constants.damagesRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.DEPOSIT,
                        title: "nav.deposits_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.DEPOSIT,
                        icon: "heroicons_outline:product-new",
                        link: Constants.depositsRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.INVENTORY,
                        title: "nav.inventory_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.INVENTORY,
                        icon: "heroicons_outline:cost2-new",
                        link: Constants.inventoryRoute,
                        exactMatch: true,
                    }

                ],
            },
            {
                id: "ventes",
                title: "nav.ventes_title",
                type: "collapsable",
                icon: "heroicons_outline:sales-new",
                classes: {
                    icon: ["bg-[#ff9800]"],
                },
                children: [
                    {
                        id: Constants.MODULES.QUOTE,
                        title: "nav.quotes_title",
                        type: "basic",
                        link: Constants.quotesRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.QUOTE,
                        icon: "heroicons_outline:devis-new",
                    },
                    {
                        id: Constants.MODULES.PURCHASE_ORDER,
                        title: "nav.order_vouchers_title",
                        type: "basic",
                        link: Constants.ordersVouchersRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.PURCHASE_ORDER,
                        icon: "heroicons_outline:delivery-invoice-new",
                    },
                    {
                        id: Constants.MODULES.DELIVERY_NOTE,
                        title: "nav.all_delivery_notes_title",
                        type: "basic",
                        icon: "heroicons_outline:delivery-invoice-new",
                        link: "all-delivery-notes",
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.DELIVERY_NOTE,
                    },
                    {
                        id: Constants.MODULES.INVOICE,
                        title: "nav.all_invoices_title",
                        type: "basic",
                        icon: "heroicons_outline:invoices-new",
                        link: Constants.allInvoicesRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.INVOICE,
                    },
                    {
                        id: Constants.MODULES.RETURN_VOUCHER,
                        title: "nav.all_return_vouchers_title",
                        type: "basic",
                        icon: "heroicons_outline:return-new",
                        link: Constants.allReturnvouchersRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.RETURN_VOUCHER,
                    },
                    {
                        id: Constants.MODULES.CREDIT_NOTE,
                        title: "nav.all_assets_title",
                        type: "basic",
                        icon: "heroicons_outline:avoirs-new",
                        link: Constants.allCreditNotesRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.CREDIT_NOTE,
                    },
                ],
            },
            {
                id: Constants.operations,
                title: "nav.operations_title",
                type: "collapsable",
                icon: "heroicons_outline:operations_icon",
                classes: {
                    icon: ["bg-[#00904B]"],
                },
                children: [
                    {
                        id: Constants.MODULES.TECHNICIAN,
                        title: "nav.technicians_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.TECHNICIAN,
                        icon: "heroicons_outline:technician_icon",
                        link: Constants.technicianRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.VEHICLE,
                        title: "nav.vehicles_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.VEHICLE,
                        icon: "heroicons_outline:vehicules_icon",
                        link: Constants.vehicleRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.INTERVENTION,
                        title: "nav.interventions_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.INTERVENTION,
                        icon: "heroicons_outline:intervention_icon",
                        link: Constants.interventionRoute,
                        exactMatch: true,
                    }
                ]
            },
            {
                id: Constants.MODULES.SAV,
                title: "nav.sav_title",
                type: "collapsable",
                icon: "heroicons_outline:sav_icon",
                exactMatch: true,
                classes: {
                    icon: ["bg-[#00904B]"],
                },
                children: [
                    {
                        id: Constants.MODULES.REPAIR_ORDER,
                        title: "nav.reparation_order",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.REPAIR_ORDER,
                        icon: "heroicons_outline:reparation_order_icon",
                        link: Constants.reparationOrdersRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SAV_INTERVENTION,
                        title: "nav.sav_intervention_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.SAV_INTERVENTION,
                        icon: "heroicons_outline:intervention_icon",
                        link: Constants.savInterventionRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SAV_QUOTE,
                        title: "nav.sav_quotes_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.SAV_QUOTE,
                        icon: "heroicons_outline:devis-new",
                        link: Constants.savQuotesRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SAV_DELIVERY_NOTE,
                        title: "nav.sav_delivery_note",
                        type: "basic",
                        icon: "heroicons_outline:devis-new",
                        moduleCodeName: Constants.MODULES.SAV_DELIVERY_NOTE,
                        link: Constants.savDeliveryNoteRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SAV_INVOICE,
                        title: "nav.sav_invoice_title",
                        type: "basic",
                        icon: "heroicons_outline:devis-new",
                        moduleCodeName: Constants.MODULES.SAV_INVOICE,
                        link: Constants.savInvoicesRoute,
                        exactMatch: true,
                    },
                    // {
                    //   id: "EXECUTION",
                    //   title: "execution",
                    //   translate: "FOLDER_NAV.EXECUTION.TITLE",
                    //   type: "item",
                    //   icon: "heroicons_outline:receipt_approved-new",
                    //   svgIcon: true,
                    //   url: "execution",
                    //   exactMatch: true,
                    //   parentRoute: "folder",
                    //   hidden: true,
                    // },
                ],
            },
            {
                id: Constants.purchasesIdRoute,
                title: "nav.purchases_title",
                type: "collapsable",
                context: AppContextModel.globalContext,
                icon: "heroicons_outline:buying-new",
                exactMatch: true,
                classes: {
                    icon: ["bg-[#2485bd]"],
                },
                children: [
                    {
                        id: Constants.allProvidersIdRoute,
                        title: "nav.all_providers_title",
                        type: "basic",
                        icon: "heroicons_outline:supplier-new",
                        moduleCodeName: Constants.MODULES.PROVIDER,
                        link: Constants.allProvidersRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.allSupplierPurchaseOrderIdRoute,
                        title: "nav.bdc_providers_title",
                        type: "basic",
                        moduleCodeName: Constants.MODULES.SUPPLIER_PURCHASE_ORDER,
                        icon: "heroicons_outline:supplier-new",
                        link: Constants.allSupplierPurchaseOrderRoute,
                        exactMatch: true,

                    },
                    {
                        id: Constants.MODULES.RECEIPT_VOUCHER,
                        title: "nav.all_receipt_vouchers_title",
                        type: "basic",
                        icon: "assignment_turned_in",
                        moduleCodeName: Constants.MODULES.RECEIPT_VOUCHER,
                        link: Constants.allRecieptvouchersRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SUPPLIER_INVOICE,
                        title: "nav.all_provider_invoices_title",
                        type: "basic",
                        icon: "receipt",
                        moduleCodeName: Constants.MODULES.SUPPLIER_INVOICE,
                        link: Constants.allProviderInvoicesRoute,
                        exactMatch: true,
                    },
                    {
                        id: Constants.MODULES.SUPPLIER_RETURN_ORDER,
                        title: "nav.all_return_provider_title",
                        moduleCodeName: Constants.MODULES.SUPPLIER_RETURN_ORDER,
                        type: "basic",
                        icon: "heroicons_outline:supplier-new",
                        link: Constants.allReturnProviderRoute,
                        exactMatch: true,
                    },
                ],
            },
            {
                id: Constants.treasurershipIdRoute,
                title: "nav.treasurership_title",
                type: "collapsable",
                icon: "credit_card",
                classes: {
                    icon: ["bg-[#009688]"],
                },
                exactMatch: true,
                children: [
                    {
                        id: Constants.MODULES.CASH_RECEIPT,
                        title: "nav.all_cashings_title",
                        type: "basic",
                        icon: "heroicons_outline:receipt_approved-new",
                        link: Constants.allCashingsRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.CASH_RECEIPT,
                    },
                    {
                        id: Constants.MODULES.DISBURSEMENT,
                        title: "nav.all_disbursments_title",
                        type: "basic",
                        icon: "heroicons_outline:receipt_approved-new",
                        link: Constants.allDisbursmentsRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.DISBURSEMENT,
                    },
                    {
                        id: Constants.MODULES.CASH_DESK,
                        title: "nav.all_boxs_title",
                        type: "basic",
                        icon: "heroicons_outline:receipt_approved-new",
                        link: Constants.allBoxsRoute,
                        exactMatch: true,
                        moduleCodeName: Constants.MODULES.CASH_DESK,
                    },
                ],
            },
            {
                id: Constants.MODULES.STATISTICS,
                title: "nav.statistics_title",
                type: "basic",
                moduleCodeName: Constants.MODULES.STATISTICS,
                icon: "heroicons_outline:statistics",
                classes: {
                    icon: ["bg-[#7e3300]"],
                },
                link: Constants.statisticsRoute,
            },
        ],
    },
    /** administration routes */

    {
        id: "admin_client_account",
        title: "nav.admin_client_account",
        type: "basic",
        icon: "heroicons_outline:user_account",
        classes: {
            icon: ["bg-[#0ED11C]"],
        },
        context: AppContextModel.administrationContext,
        link: Constants.viewRoute,
    },
    {
        id: 'admin-global-dashboard',
        title: 'nav.admins_global_dashboard',
        type: 'basic',
        icon: "heroicons_outline:dashboard",
        classes: {
            icon: ["bg-[#AC25C3]"],
        },
        context: AppContextModel.administrationContext,
        link: Constants.dashboardRoute,
    },
    {
        id: "admin_admins",
        title: "nav.admins",
        type: "basic",
        icon: "heroicons_outline:settings",
        classes: {
            icon: ["bg-[#AC25C3]"],
        },
        context: AppContextModel.administrationContext,
        link: Constants.adminsRoute,
    },
    {
        id: "admin_users",
        title: "nav.admin_users",
        type: "basic",
        icon: "heroicons_outline:customers",
        classes: {
            icon: ["bg-[#495DCF]"],
        },
        context: AppContextModel.administrationContext,
        link: Constants.usersRoute,
    },
];

export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
